import { enableProdMode, StaticProvider } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { MsalGuardConfiguration, MsalInterceptorConfiguration, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation } from '@azure/msal-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

export function MSALInstanceFactory(): IPublicClientApplication {
  const currentHostname = window.location.hostname;
  const isLocalhost = currentHostname.toLowerCase().indexOf('localhost') >= 0;
  const currentSiteUrl = (isLocalhost)
    ? `https://${currentHostname}:${window.location.port}`
    : `https://${currentHostname}`;
  const msalRedirectUri = environment.hostname;
  return new PublicClientApplication({
    auth: {
      clientId: environment.azure.clientId,
      authority: `https://login.microsoftonline.com/${environment.azure.tenant}`,
      redirectUri: msalRedirectUri,
      postLogoutRedirectUri: currentSiteUrl
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  const scope = `api://${environment.azure.clientId}/user_impersonation`;
  if (environment.webApiHost !== 'UNKNOWN') {
    protectedResourceMap.set(environment.webApiHost, [scope]);
  }
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [`api://${environment.azure.clientId}/user_impersonation`]
    }
  };
}

if (environment.production) {
  enableProdMode();
}

// Unregister any stale service workers from previous deployments.
// Old ngsw workers can intercept chunk requests and return errors for unknown hashes.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
}

const providers: StaticProvider[] = [
  { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
  { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
  { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory }
];

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch(err => {
    // ChunkLoadError: retry once by reloading the page when a lazy chunk fails to load.
    if (err && err.name === 'ChunkLoadError') {
      if (!sessionStorage.getItem('chunk_reload_attempted')) {
        sessionStorage.setItem('chunk_reload_attempted', '1');
        window.location.reload();
      }
    }
    console.error(err);
  });
